import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import noop from 'lodash/noop';
import { usePrevious } from '@Pages/RetroSynthesis/ProjectRoute/hooks';
import { trackOptionRadio } from '@Pages/StructureEditor/analytics';
import { RadioButtonGroup } from '@els/els-react--radio-button';

function RadioWithTracking({ currentValue, onChange, ...rest }) {
  const prevValue = usePrevious(currentValue);

  useEffect(() => {
    if (currentValue !== prevValue && prevValue === rest.value) {
      trackOptionRadio(rest.name, rest.value, rest.label, false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentValue, prevValue]);

  // Always call onChange with rest.value to ensure parent state is updated correctly
  const handleChange = () => {
    trackOptionRadio(rest.name, rest.value, rest.label, true);
    onChange(rest.value);
  };

  return <RadioButtonGroup.Option {...rest} onChange={handleChange} checked={currentValue === (rest.value ?? '')} />;
}

RadioWithTracking.propTypes = {
  currentValue: PropTypes.string,
  onChange: PropTypes.func,
};

RadioWithTracking.defaultProps = {
  onChange: noop,
};

export default RadioWithTracking;
